import { Component, OnInit } from "@angular/core";
import { PostsService } from "./posts.service";
import { PostTranslation } from "../shared/translation.service";

@Component({
  selector: "create-post",
  template: require('./createpost.component.html'),
  styles: [require('./createpost.component.scss')]
})
export class CreatePostComponent implements OnInit {
  post: any = {
    active: false,
    context: {
      project_ids: [],
      nationalities: [],
      employer_ids: [],
      countries: []
    },
    data: {
      content: {}
    }
  };
  translations: any[] = [];
  languages: any[] = this.service.getLanguages();
  postTypes: any[] = this.service.getPostTypes();
  sent: boolean = false;
  activePanels: string[] = ["visibility"];
  submitted: boolean = false;

  constructor(private service: PostsService) {
    // Do stuff
  }

  ngOnInit() {
    this.addTranslation();
    this.translations[0].language = "en";
    this.post.type = this.postTypes[0].key;
  }

  addTranslation() {
    this.translations.push(new PostTranslation());
    this.activePanels.push("translations" + (this.translations.length - 1));
    // this.activePanels = ['translations' + (this.translations.length - 1)];
  }

  deleteTranslation(item: any) {
    let index = this.translations.indexOf(item);
    if (index > -1) {
      this.translations.splice(index, 1);
      this.activePanels.splice(this.activePanels.length - 1, 1);
    }
  }

  getPanelTitle(translation: PostTranslation, first: boolean) {
    let text;
    let selectedLang = this.languages.filter((language: any) => {
      return language.key === translation.language;
    })[0];
    text =
      selectedLang && selectedLang.value
        ? selectedLang.value
        : "Choose a language";
    if (first) {
      text += " (Default)";
    }
    return text;
  }

  setDefault(index: number) {
    let t = this.translations[0];
    this.translations[0] = this.translations[index];
    this.translations[index] = t;
  }

  onSubmit() {
    this.activePanels = [];
    setTimeout(() => {
      this.save();
    }, 1);
  }

  save() {
    if (!this.sent) {
      this.submitted = true;
      this.sent = true;
      let defLang;
      this.translations.map((it: any) => {
        if (it.language !== "") {
          if (!defLang) {
            defLang = it.language;
          }
          this.post.data.content[it.language] = {
            title: it.title,
            author: it.author
          };
          if (this.post.type === "info") {
            this.post.data.content[it.language].subtitle = it.subtitle;
          } else if (this.post.type === "info-detailed") {
            this.post.data.content[it.language].post_summary = it.post_summary;
            this.post.data.content[it.language].post_details = it.post_details;
          }
        }
      });
      this.post.data.default_lang = defLang;
      this.service.createPost(this.post).subscribe(
        (response) => {
          this.sent = false;
          this.back();
        },
        (error) => {
          this.activePanels = ["visibility"];
          this.translations.map((it, index) => {
            this.activePanels.push("translations" + index);
          });
          this.sent = false;
        }
      );
    }
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/posts/createpost.component.ts